<div class="main-layout">
  <app-sidebar
    [isCollapsed]="isSidebarCollapsed"
    [isMobileOpen]="isMobileSidebarOpen"
    (closeMobile)="closeMobileSidebar()"
  ></app-sidebar>

  <div class="right-section">
    <app-header
      [isCollapsed]="isSidebarCollapsed"
      [isMobileOpen]="isMobileSidebarOpen"
      (sidebarToggle)="toggleSidebar()"
    ></app-header>

    <main class="main-content">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
  </div>

  <!-- Doocti CTI Panel — only rendered for agent users -->
  @if (showDoocti) {
    <app-doocti-container></app-doocti-container>
  }
</div>
